import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-status-complete",
  "use": "svg-icon-status-complete-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"svg-icon-status-complete\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M24 12c0 6.628-5.372 12-12 12-6.627 0-12-5.372-12-12C0 5.373 5.373 0 12 0c6.628 0 12 5.373 12 12\" fill=\"#8BC53F\" /><path stroke=\"#FFF\" stroke-width=\"2.5\" d=\"M7.208 12l3.594 3.594 5.99-7.188\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol